import React, { useEffect } from 'react';
import { Button } from '@sparebankenvest/splash-ui';
import styled from 'styled-components';
import i18n from '../i18n';
import { normalizeMoney } from '../format.util';
import KontaktOss from './KontaktOss';
import { capitalizeFirstLetter } from './Postnummer';
import { labelStyle } from './Forms';
import GAEvent from '../utils/ga';

const Table = styled.table`
  border-collapse: collapse;
  width: 100%;
  max-width: 390px;
  margin: 12px -8px 36px;
  tr:nth-of-type(odd) {
    background: #EAEAEA;
  }
  td {
    font-size: 16px;
    line-height: 22px;
    color: #444;
    padding: 5px 8px;
    &:nth-of-type(2) {
      text-align: right;
      font-weight: bold;
    }
  }
`;

const Header = styled.h1`
  font-family: 'Roboto';
  ${labelStyle}
`;

const Amount = styled.p`
  color: #6C6C6C;
  font-family: 'Oswald';
  font-size: 48px;
  font-weight: 700;
  line-height: 48px;
  margin: 8px 0 12px;
  small {
    font-size: 30px;
    padding-left: 12px;
  }
`;

const ButtonLink = styled(Button)`
  color: #0073B2;
  margin-top: 10px;
  margin-bottom: 20px;
`;

const InfoText = styled.p`
  color: #777777;
  max-width: 390px;
`;

const Resultat = ({
  beregnetVerdi,
  boligverdi,
  laantakerAlder,
  medlaantakerAlder,
  fellesgjeld,
  borettslagsleilighet,
  goBack,
}) => {
  useEffect(() => {
    const loanPossible = beregnetVerdi && beregnetVerdi.engangsUtbet > 0;
    if (loanPossible) {
      GAEvent({
        action: 'Godkjent',
        data: {
          boligverdi,
          laneverdi: beregnetVerdi.engangsUtbet, 
        },
      });
    } else {
      GAEvent({
        action: 'Avslag',
        data: {
          begrunnelse: fellesgjeld > 0 ? 'fellesgjeld' : 'boligverdi',
        },
      });
    }
  }, []);
  return (
    <section>
      <ButtonLink variant="link" onClick={goBack}>
        Gå tilbake
      </ButtonLink>
      <section>
        <Header>Du oppgav:</Header>
        <Table>
          <tbody>
            <tr>
              <td>
                Postnummer:
              </td>
              <td>
                {capitalizeFirstLetter(beregnetVerdi.areacodeInfo[1])}
              </td>
            </tr>
            <tr>
              <td>
                Boligens verdi:
              </td>
              <td>
                {normalizeMoney(boligverdi)}
              </td>
            </tr>
            <tr>
              <td>
                Borettslagsleilighet:
              </td>
              <td>
                {borettslagsleilighet === 'Ja' ? 'Ja' : 'Nei'}
              </td>
            </tr>
            {borettslagsleilighet === 'Ja' && (
              <tr>
                <td>
                  Fellesgjeld:
                </td>
                <td>
                  {normalizeMoney(fellesgjeld)}
                </td>
              </tr>
            )}
            <tr>
              <td>
                Alder låntaker:
              </td>
              <td>
                {laantakerAlder}
              </td>
            </tr>
            {medlaantakerAlder ? (
              <tr>
                <td>
                  Alder medlåntaker:
                </td>
                <td>
                  {medlaantakerAlder}
                </td>
              </tr>
            ) : null}
          </tbody>
        </Table>
      </section>
      { beregnetVerdi && beregnetVerdi.engangsUtbet > 0 && boligverdi > 0 && laantakerAlder !== 0 &&  beregnetVerdi.areacodeInfo && beregnetVerdi.areacodeInfo[2] === 'Grønn' && beregnetVerdi.areacodeInfo
        && (
          <>
            <section>
              <Header>
                {i18n(i => i.DU_KAN_FAA)}
              </Header>
              <Amount>
                {normalizeMoney(beregnetVerdi.engangsUtbet)}<small>kr</small>
              </Amount>
              <InfoText>
                {i18n(i => i.KRITERIERTEKST)}
              </InfoText>
            </section>
            <KontaktOss 
              title="Kontakt oss så hjelper vi deg videre:"
            />
          </>
      )}
      { beregnetVerdi && (beregnetVerdi.engangsUtbet === 0) && boligverdi > 0 && laantakerAlder !== 0 && beregnetVerdi.areacodeInfo && beregnetVerdi.areacodeInfo[2] === 'Grønn' && beregnetVerdi.isInnenforSPV
        && (fellesgjeld > 0
          && (
            <KontaktOss 
              title={i18n(i => i.KAN_IKKE_FAA_LAAN_HØY_FELLESGJELD)}
              noContact
            />
      ))}
      { beregnetVerdi && (beregnetVerdi.engangsUtbet === 0) && boligverdi > 0 && laantakerAlder !== 0 && beregnetVerdi.areacodeInfo && beregnetVerdi.areacodeInfo[2] === 'Grønn' && beregnetVerdi.isInnenforSPV
        && (fellesgjeld === 0
          && (
            <KontaktOss 
              title={i18n(i => i.KAN_IKKE_FAA_LAAN_LAV_BOLIGVERDI)}
              noContact
            />
      ))}
    </section>
  );
};

export default Resultat;